import { useEffect } from "react";
import { useAuth } from "src/contexts/AuthContext";

/**
 * Hook that automatically signs in users anonymously if they're not authenticated
 * This ensures all users have a valid auth state for accessing the app
 */
export const useAutoAuth = (): void => {
  const { user, loading, signInAnonymous } = useAuth();

  useEffect(() => {
    // Only attempt sign-in after initial auth state check is complete
    if (!loading && !user) {
      signInAnonymous().catch((error) => {
        console.error("Failed to auto sign-in:", error);
      });
    }
  }, [user, loading, signInAnonymous]);
};
